import React from 'react';
import InputComponent from '../InputComponent';
import { useEffect } from 'react';
const NumberInput = (props) => {
    const onInputChanged = (e) => {
        props.changed(e.target.value);
    };
    let maxLength = null;
    let minLength = null;
    let max = null;

    if (props.validate) {
        maxLength = !!props.validate.maxLength ? props.validate.maxLength : null;
        minLength = props.validate.minLength ? props.validate.minLength : null;
        max = props.validate.max ? props.validate.max : null;
    }
    return props?.type === 128 ? (
        <InputComponent
            id={props.answerInternalIdentifier}
            name={props.questionId}
            value={props.value}
            type="number"
            className={`w-100  ${!props.placeholder && !props.questionText ? ' input-default' : ''}`}
            placeholder={props.placeholder || props.questionText}
            invalid={props.error?.[props.questionId]}
            onChange={(e) => {
                onInputChanged(e);
            }}
            onBlur={props.handleOnBlur}
            {...props.validate}
            maxLength={2}
            disabled={props.disable}
            minLength={1}
            min={0}
            max={99}
            onTouchEnd={props.handleOnBlur}
            // validations={['required']}
        />
    ) : (
        <InputComponent
            id={props.answerInternalIdentifier}
            name={props.questionId}
            value={props.value}
            type="tel"
            className={`w-100  ${!props.placeholder && !props.questionText ? ' input-default' : ''}`}
            placeholder={props.placeholder || props.questionText}
            invalid={props.error?.[props.questionId]}
            onChange={(e) => {
                if (max && e.target.value > max) {
                    e.target.value = props.value === 0 ? '' : props.value;
                    onInputChanged(e);
                } else onInputChanged(e);
            }}
            onBlur={props.handleOnBlur}
            {...props.validate}
            maxLength={maxLength}
            disabled={props.disable}
            minLength={minLength}
            min={0}
            max={max}
            onTouchEnd={props.handleOnBlur}
            // validations={['required']}
        />
    );
};

export default NumberInput;
